import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=788d03a6&scoped=true&"
import script from "./FAQPage.vue?vue&type=script&lang=js&"
export * from "./FAQPage.vue?vue&type=script&lang=js&"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=788d03a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d03a6",
  null
  
)

export default component.exports